// extracted by mini-css-extract-plugin
export var buttonWrap = "FormSubmit-module--buttonWrap--bd411";
export var fadeInAnimation = "FormSubmit-module--fadeInAnimation--dbd6b";
export var ndaWrapper = "FormSubmit-module--ndaWrapper--94e42";
export var privacyIcon = "FormSubmit-module--privacyIcon--a4963";
export var privacyText = "FormSubmit-module--privacyText--1a54c";
export var privacyWrap = "FormSubmit-module--privacyWrap--0e37f";
export var submit = "FormSubmit-module--submit--67e42";
export var withoutButton = "FormSubmit-module--withoutButton--25f67";